<template>
  <transition name="fade">
    <div class="container-fluid side-menu">
      <div class="version">
        {{ version }}
      </div>
      <div
        ref="topMenu"
        class="row topMenu">
        <div class="col-10 pt-3 pb-3 column">
          <div
            :class="{'image-wrapper': !selectedProfilePictureIsDefault, 'image-wrapper-icon': selectedProfilePictureIsDefault}"
            class="d-inline-block align-middle mr-3"
            @click="goTo('/dashboard/profile')">
            <i
              v-if="selectedProfilePictureIsDefault"
              class="fas fa-user"/>
            <img
              v-else
              :src="selectedProfilePictureString">
          </div>
          <div
            class="name-wrapper d-inline-block"
            @click="goTo('/dashboard/profile')">
            <span class="font-weight-bold name">{{ selectedMember.firstName }} {{ selectedMember.lastName }}</span>
          </div>
        </div>
        <div class="col-2 text-right">
          <div class="close-button d-inline-block">
            <IconLink
              :class-name="{'d-inline-block': true}"
              icon="fas fa-times"
              @click="hide"/>
          </div>
        </div>
      </div>
      <div
        ref="contentMenu"
        :style="'padding-top: ' + topMenuHeight + 'px;'"
        class="contentMenu">
        <menu-item
          v-for="(menu, index) in menus"
          :key="index"
          :to="menu.to"
          :sub-menus="menu.subMenus"
          @click="hide">{{ $t(menu.text) }}</menu-item>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';
import SideMenus from '@/SideMenus.json';
import IconLink from '@/components/Utils/IconLink';
import MenuItem from '@/components/Menu/MenuItem';
import { Version } from '@/config';

export default {
  name: 'SideMenu',
  components: {
    MenuItem,
    IconLink,
    Version,
  },
  props: {},
  data() {
    return {
      topMenuHeight: null,
      menus: SideMenus,
    };
  },
  computed: {
    ...mapState('member', ['selectedMember', 'selectedProfilePictureString', 'selectedProfilePictureIsDefault']),
    version() {
      return Version;
    },
  },
  created() {
    this.$store.dispatch('member/currentProfilePicture');
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.updateRender);
      this.updateRender();
    });
  },
  methods: {
    goTo(route) {
      this.$router.push(route);
      this.$emit('close');
    },
    hide() {
      this.$emit('close');
    },
    updateRender() {
      if (this.$refs.topMenu) {
        this.topMenuHeight = this.$refs.topMenu.offsetHeight;
      }
    },
  },
};
</script>

<style scoped lang="scss">
div {
  &.side-menu {
    position: absolute;
    z-index: 4000;
    background-color: $base;
    width: 100%;
    min-height: 100%;
    top: 0;

    .topMenu {
      background-color: $primary;
      position: fixed;
      width: 100%;
      z-index: 5000;
    }

    .contentMenu {
      background-color: $base;
      padding-bottom: 37px;
    }

    &.column {
      display: flex;
      align-items: center;
    }
  }

  &.close-button {
    color: $secondary;
    font-size: 30px;
    position: absolute;
    right: 15px;
    top: 15px;
  }
  &.version {
    color: $primary;
    font-size: 1rem;
    position: absolute;
    right: 15px;
    bottom: 5px;
  }

  &.image-wrapper {
    img {
      background-color: $base;
      border: solid 3px $base;
      width: 70px;
      height: 70px;
      border-radius: 50%;
      object-fit: cover;
      object-position: center right;
    }
  }

  &.image-wrapper-icon {
    position: relative;
    background-color: $base;
    border: solid 3px $base;
    border-radius: 50%;
    width: 70px;
    height: 70px;
    overflow: hidden;
    cursor: pointer;

    i {
      position: absolute;
      width: 100%;
      background-color: $base;
      font-size: 4rem;
      color: $primary;
      text-align: center;
      bottom: -3px;
    }
  }

  &.image-wrapper,
  &.image-wrapper-icon,
  &.name-wrapper {
    cursor: pointer;
  }
}

span {
  &.name {
    font-size: 1.5rem;
    color: $base;
    cursor: pointer;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
